"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEventFromTemplate = exports.deleteEventTemplate = exports.editEventTemplate = exports.addEventTemplate = exports.searchEventTemplates = exports.updateEventTemplateSubscriptions = exports.getEventTemplateSubscriptions = exports.getEventTemplates = exports.selectEventTemplate = exports.resetEventTemplate = exports.getEventTemplate = void 0;

var _apiServices = require("@pingum/api-services");

var types = _interopRequireWildcard(require("./types"));

var eventTypes = _interopRequireWildcard(require("../event/types"));

var _networkDispatcher = require("../networkDispatcher");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getEventTemplate = function getEventTemplate(id) {
  return function (dispatch) {
    var promise = _apiServices.EventTemplateService.getEventTemplate(id);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_REQUESTED,
      successType: types.EVENT_TEMPLATE_SUCCESS,
      errorType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_EDIT_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem loading the workflow information',
      responseName: 'eventTemplate'
    });
    return promise;
  };
};

exports.getEventTemplate = getEventTemplate;

var resetEventTemplate = function resetEventTemplate() {
  return {
    type: types.EVENT_TEMPLATE_RESET
  };
};

exports.resetEventTemplate = resetEventTemplate;

var selectEventTemplate = function selectEventTemplate(selectedEventTemplate) {
  return {
    type: types.EVENT_TEMPLATE_SELECTION,
    selectedEventTemplate: selectedEventTemplate
  };
};

exports.selectEventTemplate = selectEventTemplate;

var getEventTemplates = function getEventTemplates() {
  var includeArchived = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var pagination = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch) {
    dispatch({
      type: types.EVENT_TEMPLATE_INCLUDE_ARCHIVED_UPDATED,
      includeArchived: includeArchived
    });
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATES_REQUESTED,
      successType: types.EVENT_TEMPLATES_SUCCESS,
      errorType: types.EVENT_TEMPLATES_ERROR,
      promise: _apiServices.EventTemplateService.getEventTemplates(includeArchived, pagination),
      defaultErrorMessage: 'There was a problem loading event templates',
      responseName: 'eventTemplates'
    });
  };
};

exports.getEventTemplates = getEventTemplates;

var getEventTemplateSubscriptions = function getEventTemplateSubscriptions(eventTemplateId) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_REQUESTED,
      successType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_SUCCESS,
      errorType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_ERROR,
      promise: _apiServices.EventTemplateService.getEventTemplateSubscriptions(eventTemplateId),
      defaultErrorMessage: 'There was a problem loading subscriptions for the event template',
      responseName: 'eventTemplateSubscriptions'
    });
  };
};

exports.getEventTemplateSubscriptions = getEventTemplateSubscriptions;

var updateEventTemplateSubscriptions = function updateEventTemplateSubscriptions(auth0UserId, request, successMessage) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_EDIT_REQUESTED,
      successType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_EDIT_SUCCESS,
      errorType: types.EVENT_TEMPLATE_SUBSCRIPTIONS_EDIT_ERROR,
      promise: _apiServices.EventSubscriptionService.updateEventSubscription(auth0UserId, request),
      successMessage: successMessage,
      defaultErrorMessage: 'There was a problem updating the event template subscription',
      responseName: 'eventSubscription'
    });
  };
};

exports.updateEventTemplateSubscriptions = updateEventTemplateSubscriptions;

var searchEventTemplates = function searchEventTemplates() {
  var includeArchived = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var request = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch) {
    dispatch({
      type: types.EVENT_TEMPLATE_INCLUDE_ARCHIVED_UPDATED,
      includeArchived: includeArchived
    });
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_SEARCH_REQUESTED,
      successType: types.EVENT_TEMPLATE_SEARCH_SUCCESS,
      errorType: types.EVENT_TEMPLATE_SEARCH_ERROR,
      promise: _apiServices.EventTemplateService.searchEventTemplates(includeArchived, request),
      defaultErrorMessage: 'There was a problem loading event templates',
      responseName: 'eventTemplates'
    });
  };
};

exports.searchEventTemplates = searchEventTemplates;

var addEventTemplate = function addEventTemplate(newEventTemplateRequest) {
  return function (dispatch) {
    var promise = _apiServices.EventTemplateService.addEventTemplate(newEventTemplateRequest);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_ADD_REQUESTED,
      successType: types.EVENT_TEMPLATE_ADD_SUCCESS,
      errorType: types.EVENT_TEMPLATE_ADD_ERROR,
      promise: promise,
      successMessage: 'Successfully created the event template',
      defaultErrorMessage: 'There was a problem adding the event template to the organization',
      responseName: 'newEventTemplate'
    });
    return promise;
  };
};

exports.addEventTemplate = addEventTemplate;

var editEventTemplate = function editEventTemplate(eventTemplateId, editEventTemplateRequest) {
  return function (dispatch) {
    var promise = _apiServices.EventTemplateService.editEventTemplate(eventTemplateId, editEventTemplateRequest);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_EDIT_REQUESTED,
      successType: types.EVENT_TEMPLATE_EDIT_SUCCESS,
      errorType: types.EVENT_TEMPLATE_EDIT_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem editing this event template',
      successMessage: 'Successfully updated the event template',
      responseName: 'updatedEventTemplate'
    });
    return promise;
  };
};

exports.editEventTemplate = editEventTemplate;

var deleteEventTemplate = function deleteEventTemplate(eventTemplateId) {
  return function (dispatch) {
    var promise = _apiServices.EventTemplateService.deleteEventTemplate(eventTemplateId);

    (0, _networkDispatcher.dispatchNetworkRequestDynamicSuccessDispatch)({
      dispatch: dispatch,
      requestType: types.EVENT_TEMPLATE_DELETE_REQUESTED,
      successDispatch: {
        type: types.EVENT_TEMPLATE_DELETE_SUCCESS,
        eventTemplateId: eventTemplateId
      },
      errorType: types.EVENT_TEMPLATE_DELETE_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem deleting this event template',
      successMessage: 'Successfully deleted the event template',
      responseName: 'response'
    });
    return promise;
  };
};

exports.deleteEventTemplate = deleteEventTemplate;

var addEventFromTemplate = function addEventFromTemplate(eventTemplateId, addEventRequest) {
  return function (dispatch) {
    var promise = _apiServices.EventTemplateService.addEventFromTemplate(eventTemplateId, addEventRequest);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: eventTypes.EVENT_ADD_REQUESTED,
      successType: eventTypes.EVENT_ADD_SUCCESS,
      errorType: eventTypes.EVENT_ADD_ERROR,
      promise: promise,
      successMessage: 'Successfully created the event',
      defaultErrorMessage: 'There was a problem creating the event',
      responseName: 'newEvent'
    });
    return promise;
  };
};

exports.addEventFromTemplate = addEventFromTemplate;